export class Language {
  constructor(
    public hash?: string,
    public name?: string,
    public locale?: string
  ) { }

  clone() {
    return new Language(
      this.hash,
      this.name,
      this.locale
    );
  }
}
